var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{key:_vm.key},_vm._l((_vm.filters),function(item){return _c('v-chip',{key:item.key,staticClass:"mr-2",attrs:{"close":""},on:{"click:close":function($event){return _vm.cleanFilter(item.key)}}},[_vm._v(" "+_vm._s(item.name)+": "+_vm._s(item.value)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }